import React, { useContext, useState } from 'react'
import {
  IonContent,
  IonLabel,
  IonPage,
  IonSegment,
  IonSegmentButton,
  SegmentChangeEventDetail,
  useIonViewWillEnter,
} from '@ionic/react'
import { CustomSpacer, StyleIonHeader } from '../../../components'
import { AssetHold } from './AssetHold'
import { AssetFinish } from './AssetFinish'
import { AssetHistory } from './AssetHistory'
import { StoresContext } from '../../../provider/StoreProvider'
import { RouteComponentProps } from 'react-router'
import { LIST_TYPE_MY_ASSET } from '../../../common'

interface IonSegmentCustomEvent<T> extends CustomEvent<T> {
  detail: T
  target: HTMLIonSegmentElement
}

export const Asset: React.FC<RouteComponentProps> = () => {
  const { commonStore } = useContext(StoresContext)
  const [listType, setListType] = useState<LIST_TYPE_MY_ASSET>(LIST_TYPE_MY_ASSET.HOLD)

  const onSegmentChange = (e: IonSegmentCustomEvent<SegmentChangeEventDetail>) => {
    if (e.target.value !== 'HOLD' && e.target.value !== 'FINISH' && e.target.value !== 'HISTORY') {
      return
    }
    setListType(LIST_TYPE_MY_ASSET[e.target.value])
  }

  useIonViewWillEnter(() => {
    commonStore.setShowTab(false)
  })

  return (
    <IonPage>
      <StyleIonHeader type={'SUB'} title={'총 보유자산'} href={'/myPage'} />
      <IonContent>
        <IonSegment color="dark" value={listType} onIonChange={(e) => onSegmentChange(e)}>
          <IonSegmentButton value="HOLD">
            <IonLabel>소유 중</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="FINISH">
            <IonLabel>매각 완료</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="HISTORY">
            <IonLabel>거래 내역</IonLabel>
          </IonSegmentButton>
        </IonSegment>
        {listType === 'HOLD' && <AssetHold />}
        {listType === 'FINISH' && <AssetFinish />}
        {listType === 'HISTORY' && <AssetHistory />}
        <CustomSpacer spacing="20px" />
      </IonContent>
    </IonPage>
  )
}
